/**
 * Deep clone helper with fallback for older environments
 * Uses native structuredClone when available, otherwise falls back to JSON serialization
 *
 * @param obj - The object to clone
 * @returns A deep copy of the object
 */
export const deepClone = <T>(obj: T): T => {
    if (typeof structuredClone === 'function') {
        return structuredClone(obj);
    }
    // Fallback for older browsers that don't support structuredClone
    return JSON.parse(JSON.stringify(obj));
};
